var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.333333, 1.333333)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L8,1.50733333 C8.62133333,1.668 9.198,1.93333333 9.71,2.29 L9.71,2.29 L10.6666667,1.33266667 L12,2.666 L11.0426667,3.624 C11.3993333,4.13466667 11.6653333,4.71266667 11.8253333,5.33333333 L11.8253333,5.33333333 L13.3333333,5.33333333 L13.3333333,8 L11.826,8 C11.6653333,8.62066667 11.4,9.19866667 11.0433333,9.70933333 L11.0433333,9.70933333 L12,10.6666667 L10.6666667,12 L9.71,11.0426667 C9.198,11.3993333 8.62133333,11.6653333 8,11.8253333 L8,11.8253333 L8,13.3333333 L5.33333333,13.3333333 L5.33333333,11.8253333 C4.71266667,11.6653333 4.13533333,11.3993333 3.624,11.0426667 L3.624,11.0426667 L2.66666667,12 L1.33333333,10.6666667 L2.29066667,9.70933333 C1.934,9.19933333 1.668,8.62133333 1.508,8 L1.508,8 L0,8 L0,5.33333333 L1.508,5.33333333 C1.668,4.712 1.93333333,4.13466667 2.29066667,3.624 L2.29066667,3.624 L1.33333333,2.66666667 L2.66666667,1.33333333 L3.624,2.29066667 C4.13466667,1.93333333 4.712,1.668 5.33333333,1.508 L5.33333333,1.508 L5.33333333,0 L8,0 Z M6.66666667,3.66666667 C5.00981242,3.66666667 3.66666667,5.00981242 3.66666667,6.66666667 C3.66666667,8.32352092 5.00981242,9.66666667 6.66666667,9.66666667 C8.32352092,9.66666667 9.66666667,8.32352092 9.66666667,6.66666667 C9.66666667,5.00981242 8.32352092,3.66666667 6.66666667,3.66666667 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a578ad017b4e6263e14779a990c848f3.svg";
export { ForwardRef as ReactComponent };